/**
 * Skupina oprávnění pro správu zdrojů s minimální vzdáleností
 */
export enum PermissionMinimalDistances {
  /**
   * label: Přehled zdrojů s minimální vzdáleností s vazbou na všechny subjekty
   * description: Umožňuje zobrazit tabulkový přehled všech zdrojů s minimální vzdáleností
   */
  MINIMAL_DISTANCES_LIST_ALL = 'MINIMAL_DISTANCES_LIST_ALL',

  /**
   * label: Přehled zdrojů s minimální vzdáleností s vazbou na své subjekty
   * description: Umožňuje zobrazit tabulkový přehled všech zdrojů s minimální vzdáleností s vazbou na své subjekty
   */
  MINIMAL_DISTANCES_LIST_OWN = 'MINIMAL_DISTANCES_LIST_OWN',

  /**
   * label: Detail zdroje s minimální vzdáleností s vazbou na všechny subjekty
   * description: Umožňuje zobrazit detail všech zdrojů s minimální vzdáleností
   */
  MINIMAL_DISTANCES_DETAIL_ALL = 'MINIMAL_DISTANCES_DETAIL_ALL',

  /**
   * label: Detail zdroje s minimální vzdáleností s vazbou na své subjekty
   * description: Umožňuje zobrazit detail zdrojů s minimální vzdáleností s vazbou na své subjekty
   */
  MINIMAL_DISTANCES_DETAIL_OWN = 'MINIMAL_DISTANCES_DETAIL_OWN',

  /**
   * label: Vytvoření zdroje s minimální vzdáleností s vazbou na všechny subjekty
   * description: Umožňuje vytvořit zdroj s vazbou na libovolný subjekt
   */
  MINIMAL_DISTANCES_CREATE_ALL = 'MINIMAL_DISTANCES_CREATE_ALL',

  /**
   * label: Vytvoření zdroje s minimální vzdáleností s vazbou na své subjekty
   * description: Umožňuje vytvořit zdroj s vazbou na své subjekty
   */
  MINIMAL_DISTANCES_CREATE_OWN = 'MINIMAL_DISTANCES_CREATE_OWN',

  /**
   * label: Editace zdroje s minimální vzdáleností s vazbou na všechny subjekty
   * description: Umožňuje editovat zdroj s vazbou na libovolný subjekt
   */
  MINIMAL_DISTANCES_UPDATE_ALL = 'MINIMAL_DISTANCES_UPDATE_ALL',

  /**
   * label: Editace zdroje s minimální vzdáleností s vazbou na své subjekty
   * description: Umožňuje částečně editovat zdroj s vazbou na své subjekty
   */
  MINIMAL_DISTANCES_UPDATE_OWN = 'MINIMAL_DISTANCES_UPDATE_OWN',

  /**
   * label: Zneplatnění zdroje s minimální vzdáleností s vazbou na všechny subjekty
   * description: Umožňuje zneplatnit zdroj s vazbou na libovolný subjekt
   */
  MINIMAL_DISTANCES_INVALIDATE_ALL = 'MINIMAL_DISTANCES_INVALIDATE_ALL',

  /**
   * label: Zneplatnění zdroje s minimální vzdáleností s vazbou na své subjekty
   * description: Umožňuje zneplatnit zdroj s vazbou na své subjekty
   */
  MINIMAL_DISTANCES_INVALIDATE_OWN = 'MINIMAL_DISTANCES_INVALIDATE_OWN',

  /**
   * label: Obnovení zdroje s minimální vzdáleností s vazbou na všechny subjekty
   * description: Umožňuje obnovit zdroj (zneplatněný) s vazbou na libovolný subjekt
   */
  MINIMAL_DISTANCES_REVALIDATE_ALL = 'MINIMAL_DISTANCES_REVALIDATE_ALL',

  /**
   * label: Obnovení zdroje s minimální vzdáleností s vazbou na své subjekty
   * description: Umožňuje obnovit zdroj (zneplatněný) s vazbou na své subjekty
   */
  MINIMAL_DISTANCES_REVALIDATE_OWN = 'MINIMAL_DISTANCES_REVALIDATE_OWN',
}
